import { reactive } from "vue";
export function usePdfCanvas() {
    const pdfState = reactive({
        rotation: 0,

        countPdfPages: 0,
        pageNumber: 1,

        pageIsRendering: false,
        pageNumberPending: null,

        pdfCanvas: null,
        pdfDocument: null,
        scaleOffset: -0.5,
    });

    // ! ****************************/
    // !       canvas rendering    */
    // ! **************************/

    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     *
     * @returns Promise<void>
     */
    async function queueRenderPage() {
        if (pdfState.pageIsRendering) {
            pdfState.pageNumberPending = pdfState.pageNumber;
        } else {
            await renderPage();
        }
    }
    /**
     * Get page info from document, resize canvas accordingly, and render page.
     *
     * @returns Promise<void>
     */
    async function renderPage() {
        pdfState.pageIsRendering = true;
        // Using promise to fetch the page
        await pdfState.pdfDocument
            .getPage(pdfState.pageNumber)
            .then(async function(page) {
                var container = pdfState.pdfCanvas.parentElement;
                // var wrapper = document.getElementById("wrapper");//render your pdf inside a div called wrapper
                var canvas = pdfState.pdfCanvas;
                var context = canvas.getContext("2d");
                const pageWidthScale = container.clientWidth / page.view[2];
                const pageHeightScale =
                    (window.innerHeight - 128) / page.view[3];

                var scales = { 1: 3.2, 2: 4 },
                    scale = scales[window.devicePixelRatio] || 4;

                var viewport = page.getViewport({
                    scale: scale + pdfState.scaleOffset,
                });
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                var displayWidth = Math.min(pageWidthScale, pageHeightScale);
                canvas.style.width = `${(viewport.width * displayWidth) /
                    scale}px`;
                canvas.style.height = `${(viewport.height * displayWidth) /
                    scale}px`;

                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(function() {
                    console.log("Page rendered");
                });

                // Wait for rendering to finish
                await renderTask.promise.then(function() {
                    pdfState.pageIsRendering = false;
                    if (pdfState.pageNumberPending !== null) {
                        // New page rendering is pending
                        pdfState.pageNumber = pdfState.pageNumberPending;
                        renderPage();
                        pdfState.pageNumberPending = null;
                    }
                });
            });
    }

    function zoom(amount) {
        pdfState.scaleOffset += amount;
        renderPage();
    }

    // ! *************************/
    // !  add pdfs to store     */
    // ! **********************/

    /**
     * This function saves the pdf with and without the annotations
     * and renders the first page
     *
     * @param  {String} pdfUrl
     * @param  {HTMLCanvasElement} canvas
     * @returns Promise
     */
    async function setInitialPdfDocument(pdfUrl, canvas) {
        var pdfjsLib = window["pdfjs-dist/build/pdf"];

        // The workerSrc property shall be specified.
        pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${process.env.VUE_APP_PDF_JS_VERSION}/build/pdf.worker.js`;
        pdfState.pdfCanvas = canvas;
        await pdfjsLib.getDocument(pdfUrl).promise.then(async function(pdfDoc) {
            // ! we need the original pdf document to display the generated annotations
            pdfState.pdfDocument = pdfDoc;

            pdfState.countPdfPages = pdfDoc.numPages;
            pdfState.pageNumber = 1;
            // Initial/first page rendering
            await renderPage();
        });
    }

    return { pdfState, setInitialPdfDocument, queueRenderPage, zoom };
}
